import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
declare var $: any;

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.scss'],
})
export class RoleListComponent  extends BaseListCtl {
  public statusList = ['Active', 'Inactive'];
  public yesNo = ['Y', 'N'];

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    //this.form.preload["applist"] = [];
    locator.getPathVariable(route, function (params:any) {
      _self.form.searchParams['appId'] = params.get('appId');
    });
    
    _self.locator.config
      .getProperty('endpoint.role')
      .then((property: string) => {
      _self.initApiEndpoint(property);
      });
  }

  override populateForm(form:any, data:any) {
    form.id = data.id;
    form.name = data.name;
    form.discription = data.discription;
    form.status = data.status;
    form.skey = data.skey;
    form.appId = data.appId;
    form.applicationName = data.applicationName;
    form.canDelete = data.canDelete;
    form.canRead = data.canRead ;
    form.canUpdate = data.canUpdate;    
    form.canWrite = data.canWrite;        
    console.log('----->', data);
  }

  /**
   * Add a new role for the application
   * @param appId 
   */
  addRole() {
    this.get(0);
    this.form.data['appId'] = this.form.searchParams['appId'];
  }  

  /**
  * Initialize DataTable 
  */
  override async initializeDataTable(): Promise<void> {
    try {
      const tableElement = $('#dataTableId');
      if ($.fn.dataTable.isDataTable(tableElement)) {
        tableElement.DataTable().clear().destroy();
      }
      await this.waitForDocumentReady();
      if ($.fn.dataTable) {
        const table = $('#dataTableId').DataTable({
          lengthChange: false,
          paging: false, // Disable pagination
          info: false, // Disable the "Showing X to Y of Z entries" info    
          dom: '<"row align-items-center"<"col-3"f><"col-1 custom-button-container"> <"col-4 custom-add-container"><"col-4 text-right"B>>rt', // Configure the layout
          buttons: [
            {
              extend: 'copy',
            },
            {
              extend: 'excelHtml5',
            },
            {
              extend: 'pdfHtml5',
            },
            {
              extend: 'print',
            },
          ],
        });
  
        // Insert custom button HTML into the placeholder container
        $('.custom-button-container').html(`
          <a
            class="btn btn-outline-secondary btn-sm radius-30 "
            data-bs-toggle="modal"
            data-bs-target="#scrollableModal"
          
            title="Filter"
          >
            <i class="lni lni-funnel"></i> 
          </a>
        `);
        $('.custom-add-container').html(`
        <a
          class="btn btn-outline-secondary btn-sm radius-30 "
          data-bs-toggle="modal"
          data-bs-target="#editModal"        
          title="Adds"
          
        >
        <i style="font-family: 'Times New Roman', Times, serif;" class="bx bx-plus me-0"></i>Add
         
        </a>
      `);
       // Manually bind the click event using jQuery
       $('.custom-add-container a').on('click', () => {      
        this.get(0);
        this.resetForm();
        this.addRole();
      });
  
        // Append buttons container to the third col-4 element
        table
          .buttons()
          .container()
          .appendTo('#dataTableId_wrapper .col-4:eq(2)');
      } else {
        console.error(
          'DataTable is not defined. Please check if the DataTable library is correctly loaded.'
        );
      }
    } catch (error) {
      console.error('Error initializing DataTable:', error);
    }
  }
  /**
   * Wait for Documents Ready
   * @returns 
   */
  override waitForDocumentReady(): Promise<void> {
    return new Promise<void>((resolve) => {
      $(document).ready(() => {
        resolve();
      });
    });
  }
}
